import { buildVersion } from './build.version';

export const environment = {
  name: 'dev',
  production: false,
  version: buildVersion + '-DEV',
  dataCleanerUrl: 'https://api-datacleaner.kyloe.plus/uat-eu',
  dataRulesUrl: 'https://api-datarules.kyloe.plus/einardev',
  dataToolsUrl: 'https://api-datatoolsadmin.kyloe.plus/uat-eu', // data tools - the main lookup where each app in enabled.
  duplikitUrl: 'https://api-duplikit.kyloe.plus/uat-eu',
  metaDataUrl: 'https://api-datarules.kyloe.plus/einardev',
  webSocketUrl: 'wss://datarules-uat.kyloe.plus',
  clientId: 'e5e7db35-78ec-49d9-bb72-82591cfe516d', // This is the Dev Sandbox
  kyloeAuthHost: 'https://api-auth.kyloe.cloud/dev/authenticate/callback',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  ffApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',

  enableAnalytics: false,

  // AWS RUM Config
  guestRoleArn: '',
  identityPoolId: '',
  APPLICATION_ID: '',

  // Google Analytics Config
  googleAnalytics: '',
  googleAnalyticsDTLite: '',

  // Pendo
  pendoAPIKey: 'DATATOOLS APIKEY'
};
